var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApricot = function SvgApricot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apricot_svg__a)",
    d: "M124.998 200s6.09 4 17.999 4c11.91 0 53.458-20 58.418-61 3.1-25.61-6.51-47.32-21.419-60.74-8.96-8.06-18.829-13.13-29.999-14.26l-25.999 61z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#apricot_svg__b)",
    d: "M124.998 200s-4.64 1.99-10.57 2c-.99 0-3.06-.13-4.68-.41-11.78-2.01-44.778-24.17-41.528-65.45C71.11 99.48 102.39 65.99 136.157 66c4.26 0 9.55.87 13.83 2 0 0-7.86 58.07-13.75 89.28-5.889 31.22-11.249 42.72-11.249 42.72z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "apricot_svg__a",
    x1: 147.287,
    x2: 176.468,
    y1: 203.62,
    y2: 77.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1988BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "apricot_svg__b",
    x1: 84.59,
    x2: 136.651,
    y1: 191.46,
    y2: 68.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1787B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#53A6CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#B2D7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgApricot;